import React, { useState } from "react";
import "../../../../../../Assets/Styles/AI.scss";
import Alert from "../../../../Components/ShareElements/Alert/Alert";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import UploadIcon1 from "../../../../../../Assets/Images/Assistify Icons/upload-cloud 1.svg";
import UploadIcon2 from "../../../../../../Assets/Images/Assistify Icons/upload-failed.svg";
import UploadIcon3 from "../../../../../../Assets/Images/Assistify Icons/file-text 3.svg";
import UploadIcon4 from "../../../../../../Assets/Images/Assistify Icons/file-text 2.svg";
import CalendatTime from "../../../../../../Assets/Images/Assistify Icons/calendar time.svg";
import ZipIcon from "../../../../../../Assets/Images/Assistify Icons/file-zip.svg";

const UploadWidget = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [IsExtracting, setIsExtracting] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const handleErrorType = (Err) => {
    let AllowedExtensions = [".zip", ".pdf", ".docx", ".png", ".jpg", ".jpeg"];
    let FileExtension = props.Name.slice(
      props.Name.lastIndexOf("."),
      props.Name.length
    );

    if (!AllowedExtensions.includes(FileExtension)) {
      return translateText("photo_uploader_validation_error_fiormat")
        .slice(0, -1)
        .concat(", JPG , PDF, DOCX)");
    } else {
      if (
        props.ErrorMessage === "photo_uploader_validation_error_file_size" ||
        props.ErrorMessage ===
          translateText("photo_uploader_validation_error_file_size") ||
        props.ErrorMessage ===
          "photo_uploader_validation_error_file_size_single" ||
        props.ErrorMessage ===
          translateText("photo_uploader_validation_error_file_size_single")
      ) {
        return translateText(
          "photo_uploader_validation_error_file_size_single"
        );
      } else if (props.ErrorMessage === "DUPLICATED_CONTENT") {
        return translateText("duplicat_file_error_message");
      } else {
        return props.ErrorMessage;
      }
    }
  };

  const toggleCancel = () => {
    setModalIsOpen(true);
  };

  const acceptCancellation = () => {
    setModalIsOpen(false);
    props.CancelUpload();
  };

  const shortenName = (Name) => {
    if (Name.length <= 26) {
      return Name;
    } else {
      let Shortened = Name.slice(0, 22) + " ...";
      return (
        <>
          <p className="popup-text">{Name}</p>
          {Shortened}
        </>
      );
    }
  };

  const handleCheckItem = (Id) => {
    let AllIDs = [];
    let Checked = [];

    props.AllFiles.map((Item) => {
      AllIDs.push(Item.id);
    });

    AllIDs.map((ID) => {
      if (
        document.getElementById("checkbox-" + ID).checked &&
        !document.getElementById("checkbox-" + ID).disabled
      ) {
        Checked.push(ID);
      }
    });

    props.SaveCheckedItems(Checked);
  };

  return (
    <div className="container-upload-widget-photo">
      {ModalIsOpen ? (
        <Alert
          AlertText={props.Name}
          Id={props.Id + "-modal"}
          cancel={() => setModalIsOpen(false)}
          AlertInfo={"Are you sure you want to cancel?"}
          CancelText={"Close"}
          accept={() => acceptCancellation()}
          AcceptText={"Cancel upload"}
        />
      ) : null}
      <div className="upload-widget-photo">
        {props.Type === "zip" ? (
          <img className="zip-icon" alt="" src={ZipIcon} />
        ) : (
          <i className="feather-file-text"></i>
        )}
        <div className="description">
          <div
            className={
              props.Status === "success" || props.Status === "uploaded-analyzed"
                ? "image-name downloadable"
                : "image-name"
            }
            onClick={() => props.ToggleDownload()}
          >
            {shortenName(props.Name)}
          </div>

          {props.Status === "loading" && props.Progress < 100 ? (
            <>
              <div className="loading-container">
                <div
                  className="loading-indicator"
                  style={{ width: props.Progress + "%" }}
                ></div>
              </div>
              <div className="upload-text-info">
                <p>{translateText("file_uploading_state_text")}</p>
              </div>
            </>
          ) : null}
        </div>
        <section className="file-info size-info">
          <p className="widget-info-text">{"Size:"}</p>
          {" " + props.Size + " MB"}
        </section>
        {props.Status === "uploaded-analyzed" || props.Status === "success" ? (
          <section className="date-holder">
            <img alt="" src={CalendatTime} />
            <p>{props.UploadDateTime}</p>
          </section>
        ) : null}
        {props.Status === "cancelled" && (
          <div id={props.Id + "-cancelled"} className="cancelled-description">
            {translateText("cancelled_by_user")}
          </div>
        )}
        <Button
          Status={props.Status}
          Percentage={props.Progress}
          translateText={(Label) => translateText(Label)}
          HandleCancel={() => toggleCancel()}
          ToggleDelete={() => props.ToggleDelete()}
          FileId={props.FileId}
          HandleCheckItem={() => handleCheckItem()}
          RequestDeleteItem={() => props.RequestDeleteItem(props.FileId)}
        />
      </div>
      {props.Status === "failed" ? (
        <div className="error-description">
          {handleErrorType(props.ErrorMessage)}
        </div>
      ) : (
        <>
          {props.Status === "success" && props.ErrorMessage ? (
            <div className="error-description blue-info-text">
              {handleErrorType(props.ErrorMessage)}
            </div>
          ) : null}
        </>
      )}

      {props.Status === "uploaded-failed" && (
        <div className="error-description">{props.ErrorMessage}</div>
      )}
    </div>
  );
};

//Status: success, loading, cancelled, failed, uploaded-failed, uploaded-analyzed
const Button = (props) => {
  const CheckItem = () => {
    props.HandleCheckItem();
  };

  if (props.Status === "success") {
    return (
      <span className="file-actions">
        <img alt="" src={UploadIcon1} />
        <span className="extract-btn">
          <i
            className="feather-x cross-icon"
            onClick={() => props.ToggleDelete()}
          />
        </span>
        <label className="blue-checkbox-rounded-label">
          <input
            onChange={() => CheckItem()}
            type="checkbox"
            class="blue-checkbox"
            id={"checkbox-" + props.FileId}
          />
          <i></i>
        </label>
      </span>
    );
  }
  if (props.Status === "loading") {
    return (
      <span className="rotator">
        <img alt="" src={Rotator} />
      </span>
    );
  }
  if (props.Status === "failed") {
    return (
      <span className="file-actions">
        <img alt="" src={UploadIcon2} />
        <i
          className="feather-x cross-icon"
          onClick={() => props.RequestDeleteItem()}
        />
        <label className="blue-checkbox-rounded-label disabled-checkbox-wrapper">
          <input
            onChange={() => CheckItem()}
            type="checkbox"
            class="blue-checkbox"
            disabled
            id={"checkbox-" + props.FileId}
          />
          <i></i>
        </label>
      </span>
    );
  }
  if (props.Status === "uploaded-failed") {
    return (
      <span className="file-actions">
        <img alt="" src={UploadIcon3} />
        <i
          className="feather-trash-2 cross-icon"
          onClick={() => props.ToggleDelete()}
        />
        <label className="blue-checkbox-rounded-label disabled-checkbox-wrapper">
          <input
            onChange={() => CheckItem()}
            type="checkbox"
            disabled
            class="blue-checkbox"
            id={"checkbox-" + props.FileId}
          />
          <i></i>
        </label>
      </span>
    );
  }
  if (props.Status === "uploaded-analyzed") {
    return (
      <span className="file-actions">
        <img alt="" src={UploadIcon4} />
        <i
          className="feather-trash-2 cross-icon"
          onClick={() => props.ToggleDelete()}
        />
        <label className="blue-checkbox-rounded-label disabled-checkbox-wrapper">
          <input
            onChange={() => CheckItem()}
            disabled
            type="checkbox"
            class="blue-checkbox"
            id={"checkbox-" + props.FileId}
          />
          <i></i>
        </label>
      </span>
    );
  }
  if (props.Status === "cancelled") {
    return <i className="feather-x cross-icon" onClick={() => null} />;
  }
};

export default UploadWidget;
